import React from "react"
import { Box, useTheme } from "@material-ui/core"
import { t } from "@lingui/macro"

const ErrorLabel = ({ message, ...rest }) => {
  const theme = useTheme()

  if (!message) return null

  return (
    <Box style={{ color: theme.palette.error.main }} {...rest}>
      {t`${message}`}
    </Box>
  )
}

export { ErrorLabel }
